package com.hyperether.goodjob.database

import kotlin.Long
import kotlin.String

public data class Team(
  public val id: Long,
  public val _id: String?,
  public val name: String?,
  public val workspaceId: String?,
  public val employees: String?,
  public val type: String?,
  public val createdAt: String?,
  public val updatedAt: String?,
)
